module.exports = __webpack_public_path__ + "img/operator4.d03f916c.png";